import React, { useCallback } from "react";
import { BsCaretDownFill, BsCaretUpFill } from "react-icons/bs";

import { SORT_DESTINATION, SortDestination, SpaceGroupOrderFields } from "constants/sort.ts";
import { cn } from "utils/cn";

const { ASC, DESC } = SORT_DESTINATION;

export const ParkingDetailTableSortField = ({
  field,
  name,
  index,
  onSort,
  sortDirection,
  sortField,
}: {
  field?: SpaceGroupOrderFields;
  name: string;
  index?: number;
  sortField?: SpaceGroupOrderFields;
  sortDirection: SortDestination | "";
  onSort: (field: SpaceGroupOrderFields) => void;
}) => {
  const handleOnSort = useCallback(() => {
    if (field == null) return;
    onSort(field);
  }, [field, onSort]);

  const isActive = field === sortField;
  const isAscending = sortDirection === ASC;
  const isDescending = sortDirection === DESC;
  const showSortIcon = field != null;

  return (
    <div
      className={cn(
        "flex items-center justify-start whitespace-nowrap border-r text-[12px] text-gray",
        field && "cursor-pointer",
        index == 0 ? "" : "pl-[14px]"
      )}
      onClick={handleOnSort}
    >
      <span className={cn("text-gray", sortDirection && isActive && "text-black")}>{name}</span>
      {showSortIcon &&
        (isAscending && isActive ? (
          <BsCaretUpFill className="ml-2 text-gray" />
        ) : (
          <BsCaretDownFill className={cn("ml-2 text-disabled", isDescending && isActive && "text-gray")} />
        ))}
    </div>
  );
};
